/* eslint-disable */
import axios from 'axios';

 
const { additionalHeaders, updatepassword_path } = window.appAirDrop.config;

export async function postResetPw(resetPwData: ResetPwData) {
  const response = await axios.post(updatepassword_path, new URLSearchParams(resetPwData).toString(), {
    headers: {
      ...(additionalHeaders ?? {}),
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    withCredentials: true,
  });

  return response;
}
